// extracted by mini-css-extract-plugin
export default {"panel":"NavigationPanel_panel__ad4Ic","vertical":"NavigationPanel_vertical__0+za4","desktop":"NavigationPanel_desktop__LnQEb","mobile":"NavigationPanel_mobile__vHx+b"};